import { type Ref, computed } from 'vue'

import { StorePerformance } from '@/models'

import { PerformanceTableId } from '@generated/types'

interface UseRoomMapAriaLabels {
  performance: Ref<StorePerformance | null>
  selectedTableIds: Ref<PerformanceTableId[]>
  context?: 'selected' | 'confirmed'
}

export function useRoomMapAriaLabels({
  performance,
  selectedTableIds,
  context = 'selected',
}: UseRoomMapAriaLabels) {
  const roomMapAriaLabel = computed<string>(() => {
    const ids = selectedTableIds.value
    if (!ids.length) return `Venue seating map. No tables ${context}.`

    const tableReads = performance.value?.tables || []
    const tableLabels = ids.map(id => {
      const table = tableReads.find(t => t.id === id)
      const name = table?.name ?? id.toString()
      return `Table ${name}`
    })

    return `Venue seating map. ${tableLabels.join(', ')} ${context}.`
  })

  const backgroundImageAriaLabel = computed<string>(() => {
    return (
      performance.value?.room_layout?.accessibility_description ||
      'Venue layout showing table locations'
    )
  })

  return { roomMapAriaLabel, backgroundImageAriaLabel }
}
